import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import CLColorPicker from './CLColorPicker';
import { visuallyHidden } from '@mui/utils';
import AddIcon from '@mui/icons-material/Add';
import { apiCallGet, apiCallPut } from '../../../utils/action';
import Preloader from '../../../helpers/Preloader';
import SearchIcon from "@mui/icons-material/Search";
import CLSummaryButtonGroup from './CLSummaryButtonGroup';
import { timestamp } from '../../../utils/services';
import { stableSort } from '../CommentLibraryHelper';
import CLDeleteSummaryConfirm from './CLDeleteSummaryConfirm';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import "../../../../assets/styles/containers/_clTagsSummary.scss";
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import "../../../../assets/styles/containers/_clTagsSummary.scss";
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { Paper, Button, Box, Grid, TextField, Typography, Table, TableBody, TableCell, TableContainer, TableRow, IconButton, TableHead, TableSortLabel } from '@mui/material';
import AddNewSummary from './AddNewSummary';
import { saveReorderSummary } from '../../../store/action';
import { GET_CL_SUMMARY_TAG_LIST, getCommentLibrarySummaryTagList } from '../../../store/action/CommentLibraryAction';
import { useDispatch } from 'react-redux';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}> <Typography>{children}</Typography> </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function getComparator(order, orderBy) {
    const descendingComparator = (a, b, orderBy) => {
        if (typeof a[orderBy] === 'string') {
            const lowercaseA = a[orderBy].toLowerCase();
            const lowercaseB = b[orderBy].toLowerCase();
            if (lowercaseA < lowercaseB) return -1;
            else if (lowercaseA > lowercaseB) return 1;
        }
        if (a[orderBy] < b[orderBy]) return -1;
        else if (a[orderBy] > b[orderBy]) return 1;
        return 0;
    };
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

const CLSummary = () => {
    const [order, setOrder] = useState('');
    const [selected, setSelected] = useState([]);
    const [orderBy, setOrderBy] = useState('calories');
    const [showLoader, setShowLoader] = useState(false);
    const [commentListData, setCommentListData] = useState([]);
    const [initialTableData, setInitialTableData] = useState([]);
    const [commentListInititalData, setCommentListInitialData] = useState([]);
    const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);
    const [openAddNewSummaryModal, setOpenAddNewSummaryModal] = useState(false);
    const [deletedSummaryId, setDeletedSummaryId] = useState("");
    const dispacth = useDispatch();
    const handleOpenConfirmationModal = (row) => {
        setDeleteConfirmationModal(true);
        setDeletedSummaryId(row?.id);
    }
    const handleCloseConfirmationModal = () => setDeleteConfirmationModal(false);
    const handleOpenAddNewSummaryModal = () => setOpenAddNewSummaryModal(true);
    const handleCloseAddNewSummaryModal = () => setOpenAddNewSummaryModal(false);
    const GetCLSummaryList = (prependNewest = false) => {
        setShowLoader(true);
        apiCallGet(
            (response) => {
                const { data, message, success } = response.data;
                if (success) {
                    let sortedData = [...data].sort((a, b) => a.order - b.order);
                    if (prependNewest && sortedData.length > 0) {
                        const maxId = Math.max(...sortedData.map((item) => item.id));
                        const newestIndex = sortedData.findIndex((item) => item.id === maxId);
                        if (newestIndex > 0) {
                            const [newestItem] = sortedData.splice(newestIndex, 1);
                            sortedData = [newestItem, ...sortedData];
                            // Save the new order to backend, then re-fetch from the
                            // backend so any subsequent remount of AddCommentDialog
                            // (which fires its own getCommentLibrarySummaryTagList call)
                            // also receives the correct order.
                            dispacth(saveReorderSummary({ reordered_summaries: sortedData.map((item) => item.id) }))
                                .then(() => dispacth(getCommentLibrarySummaryTagList()));
                        }
                        // Immediately update the dropdown Redux state with the data
                        // we already have so the UI reflects the correct order right
                        // away, before the backend round-trip completes.
                        dispacth({ type: GET_CL_SUMMARY_TAG_LIST, payload: sortedData });
                    }
                    setCommentListData(sortedData);
                    setInitialTableData(sortedData);
                    setCommentListInitialData(sortedData);
                    setShowLoader(false);
                } else {
                    setShowLoader(false);
                    console.log("else", message);
                }
            },
            "",
            "GET_COMMENT_LIB_SUMMARY_LIST"
        );
    };

    useEffect(() => {
        if (sessionStorage.getItem('company-key')) {
            GetCLSummaryList();
        }
    }, [sessionStorage.getItem('company-key')]);

    const handleSearchFilter = (event) => {
        const query = event.toLowerCase();
        if (query === "") {
            setCommentListData(commentListInititalData);
        } else {
            const searchData = initialTableData?.filter((item) => {
                return (item?.title?.toLowerCase()?.includes(query));
            });
            setCommentListData(searchData);
        }
    };

    const EnhancedTableHead = (props) => {
        const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
            props;
        const createSortHandler = (property) => (event) => {
            onRequestSort(event, property);
        };
        return (
            <TableHead>
                <TableRow sx={{ height: "56px" }}>
                    {headCells?.map((headCell) => (
                        <TableCell
                            key={headCell.id}
                            align={'left'}
                            padding={headCell.disablePadding ? 'none' : 'normal'}
                            sortDirection={orderBy === headCell.id ? order : false}
                            className='cl-summary-table-head'
                            sx={{ padding: "14px !important", fontFamily: "Source Sans Pro" }}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                                IconComponent={() =>
                                    (headCell.id !== "order" && headCell.id !== "global" && headCell.id !== "color") ? (
                                        <UnfoldMoreIcon className='cl-summary-sort-icon' />
                                    ) : null
                                }
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        );
    }

    EnhancedTableHead.propTypes = {
        numSelected: PropTypes.number.isRequired,
        onRequestSort: PropTypes.func.isRequired,
        onSelectAllClick: PropTypes.func.isRequired,
        order: PropTypes.oneOf(['asc', 'desc']).isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number.isRequired,
    };

    const headCells = [
        { id: 'order', numeric: false, disablePadding: false, label: "  ", },
        { id: 'title', numeric: false, disablePadding: false, label: 'Name', },
        { id: 'color', numeric: false, disablePadding: false, label: 'Color', },
        { id: 'times_used', numeric: false, disablePadding: false, label: 'Times used', },
        { id: 'global', numeric: false, disablePadding: false, label: '', },
    ];

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const selectedComment = commentListData?.map((n) => n.id);
            setSelected(selectedComment);
            return;
        }
        setSelected([]);
    };
    const isSelected = (id) => selected.indexOf(id) !== -1;
    const visibleRows = useMemo(
        () =>
            stableSort(commentListData, getComparator(order, orderBy)),
        [order, orderBy, commentListData],
    );
    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };
    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
        const items = reorder(
            commentListData,
            result.source.index,
            result.destination.index
        );
        items.forEach((element, i) => {
            element.order = i + 1;
            element.updated_at = timestamp();
            return element
        });
        setCommentListData(items);
        dispacth(saveReorderSummary({ reordered_summaries: items.map(item => item.id) }))
    };

    const handleSummaryBlur = async (event, row) => {
        const updatedSummaryValue = event.target.value;
        const payload = {
            "summary_id": row?.id,
            "name": updatedSummaryValue,
            "definition": row?.definition,
            "color": row?.color
        };
        try {
            const response = await apiCallPut(
                (response) => {
                    const { success, message } = response.data;
                    if (success) {
                        GetCLSummaryList();
                    } else {
                        console.error("Update failed:", message);
                    }
                },
                payload,
                "EDIT_COMMENT_LIB_SUMMARY_LIST"
            );
            if (response?.data?.success) {
                const updatedData = commentListData.map((summary) =>
                    summary.id === row.id ? { ...summary, title: updatedSummaryValue } : summary
                );
                setCommentListData(updatedData);
            }
        } catch (error) {
            console.error("Error updating summary:", error);
        }
    };

    const handleColorChange = (id, color) => {
        const updatedRows = commentListData.map((row) => row.id === id ? { ...row, color: color } : row);
        setCommentListData(updatedRows);
    };

    return (
        <>
            <Preloader showPreloader={showLoader} />
            <Box sx={{ width: '100%', padding: "30px", paddingBottom: "0px" }}>
                <Grid container className='cl-search-container'>
                    <Grid item xs={6} md={6} lg={2} className='cl-search-bar'>
                        <div className="cl-search">
                            <TextField
                                id="search-bar"
                                onChange={(e) => handleSearchFilter(e.target.value)}
                                variant="outlined"
                                placeholder="Search in table"
                                size="small"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        height: '36px',
                                        width: '216px',
                                        borderColor: "#D5D5D5 !important",
                                        "&:hover .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#ccc",
                                        },
                                        "& .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#ccc",
                                        },
                                    },
                                    '& .MuiInputBase-input::placeholder': {
                                        fontSize: '16px !important',
                                        fontFamily: "Source Sans Pro !important",
                                    }
                                }}
                            />
                            <SearchIcon className="cl-summary-search-icon" />
                        </div>
                    </Grid>
                    <Grid item xs={6} md={6} lg={10} sx={{ gap: "5px" }}>
                        <Button startIcon={<AddIcon />} className='add-new-btn' onClick={handleOpenAddNewSummaryModal} sx={{ width: "104px !important", backgroundColor: "#0F75BC !important", fontWeight: 600 }}><span>Add new</span></Button>
                    </Grid>
                </Grid>
                <Paper sx={{ width: "100%", mb: 2, border: "1px solid #D5D5D5", borderRadius: "3px" }} className="cl-table" elevation={0}>
                    <TableContainer className="cl-table-container">
                        <Table aria-label="simple table">
                            <EnhancedTableHead
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={handleSelectAllClick}
                                onRequestSort={handleRequestSort}
                                rowCount={commentListData.length}
                            />
                            <DragDropContext onDragEnd={onDragEnd}>
                                <Droppable droppableId="droppable">
                                    {(provided) => (
                                        <TableBody
                                            {...provided.droppableProps}
                                            ref={provided.innerRef}
                                        >
                                            {commentListData.length > 0 ? (visibleRows.map((row, index) => {
                                                const isItemSelected = isSelected(row.id);
                                                const labelId = `enhanced-table-checkbox-${index}`;
                                                return (
                                                    <Draggable
                                                        key={row.id}
                                                        draggableId={"q-" + row.id}
                                                        index={index}
                                                    >
                                                        {(provided) => (
                                                            <TableRow
                                                                hover
                                                                tabIndex={1}
                                                                key={row.id}
                                                                ref={provided.innerRef}
                                                                selected={isItemSelected}
                                                                sx={{ cursor: 'pointer' }}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                aria-checked={isItemSelected}
                                                            >
                                                                <TableCell
                                                                    component="th"
                                                                    id={labelId}
                                                                    scope="row"
                                                                    size='small'
                                                                    padding="none"
                                                                    sx={{ padding: "0px 8px 0px 15px", width: "4%" }}
                                                                    className='cl-row-status cl-drag-col'
                                                                >
                                                                    <IconButton>
                                                                        <DragIndicatorIcon sx={{ color: '#878787' }} fontSize="small" />
                                                                    </IconButton>
                                                                </TableCell>
                                                                <TableCell sx={{ padding: "6px 6px 6px 0px" }} padding="none" className='cl-title-col' align="left">
                                                                    <TextField className="summary-text-field" style={{ width: "100%", minWidth: "900px" }}
                                                                        defaultValue={row.title}
                                                                        onBlur={(e) => handleSummaryBlur(e, row)}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ padding: "0px 8px 5px 8px" }} padding='none' className='cl-color-col' align="left" style={{ width: "200px", position: "relative" }}>
                                                                    <CLColorPicker row={row} onColorChange={handleColorChange} GetCLSummaryList={GetCLSummaryList} readOnly={true}/>
                                                                </TableCell>
                                                                <TableCell sx={{ padding: "0px 0px 5px 15px" }} padding='none' className='cl-times-used-col' align="left">
                                                                    <span className='times-used-text'>{row?.times_used}</span>
                                                                </TableCell>
                                                                <TableCell padding='none' align='right' width="150px" sx={{ position: "relative" }}>
                                                                    <CLSummaryButtonGroup handleOpenConfirmationModal={handleOpenConfirmationModal} row={row} />
                                                                </TableCell>
                                                            </TableRow>
                                                        )
                                                        }
                                                    </Draggable>
                                                )
                                            }
                                            )) : <TableRow style={{ height: "100%" }}>
                                                <TableCell colSpan={999} style={{ padding: 0, borderBottom: 0 }}>
                                                    <Box
                                                        display="flex"
                                                        flexDirection="column"
                                                        alignItems="center"
                                                        justifyContent="center"
                                                        height="100%"
                                                        minHeight="360px" // force some height if table has no rows
                                                        textAlign="center"
                                                    >
                                                        <Typography className="cl-empty-text">No summaries found</Typography>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>}
                                            {provided.placeholder}
                                        </TableBody>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        </Table>
                    </TableContainer>
                </Paper>
                <CLDeleteSummaryConfirm deleteConfirmationModal={deleteConfirmationModal} handleCloseConfirmationModal={handleCloseConfirmationModal} deletedSummaryId={deletedSummaryId} setDeletedSummaryId={setDeletedSummaryId} setDeleteConfirmationModal={setDeleteConfirmationModal} GetCLSummaryList={GetCLSummaryList} />
                <AddNewSummary open={openAddNewSummaryModal} handleClose={handleCloseAddNewSummaryModal} setOpenAddNewSummaryModal={setOpenAddNewSummaryModal} GetCLSummaryList={GetCLSummaryList} />
            </Box >
        </>
    )
}

export default CLSummary;
